import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactFormElevated';
import ParallaxBackground from '../components/ParallaxBackground';

const DeedTransfers = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <ParallaxBackground 
        image="/images/boathouse-row.jpg"
        className="py-32"
        overlay={true}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            Deed Transfers
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Seamless and efficient deed transfer services
          </p>
        </div>
      </ParallaxBackground>

      <section className="py-16 bg-eagle-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-eagle-dark mb-4">
              Why Eagle Closing for your Deed Transfer?
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              When it comes to transferring property ownership, a deed transfer is a crucial step that must be handled with utmost care and precision. At Eagle Closing, we specialize in facilitating seamless and efficient deed transfers, ensuring a smooth transition of ownership between parties.
            </p>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-4">
              Our experienced team understands the intricacies of the legal and administrative processes involved in deed transfers. Whether you\'re transferring property due to a sale, gift, inheritance, or other circumstances, we are here to guide you through every step of the process.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Thorough Legal Review',
                description: 'Our team conducts a comprehensive review of all relevant legal documents, including the current deed and any associated contracts, to ensure the transfer is executed accurately and in compliance with applicable laws and regulations.',
              },
              {
                title: 'Title Examination and Insurance',
                description: 'We perform a detailed title search to identify any potential issues or encumbrances that may affect the transfer. Additionally, we assist in obtaining title insurance to protect your interests and provide peace of mind regarding the property\'s ownership.',
              },
              {
                title: 'Preparation and Execution of Transfer Documents',
                description: 'Our skilled professionals handle the preparation and execution of all necessary transfer documents, including the new deed. We ensure that all required information is accurately recorded and that the transfer documents comply with local jurisdiction requirements.',
              },
              {
                title: 'Coordination with Parties Involved',
                description: 'We act as a central point of contact between all parties involved in the deed transfer, including buyers, sellers, attorneys, and other relevant stakeholders. Our team ensures open communication, timely exchange of information, and seamless coordination throughout the transfer process.',
              },
              {
                title: 'Recordation and Finalization',
                description: 'Once the transfer documents are executed, we handle the necessary steps to officially record the transfer with the appropriate governmental entity. This finalizes the transfer and establishes the new owner\'s legal rights and responsibilities.',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-eagle-dark mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-8">
              At Eagle Closing, we prioritize accuracy, efficiency, and transparency in every deed transfer we facilitate. Our goal is to make the process as smooth and stress-free as possible, allowing you to focus on the excitement of property ownership.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Contact us today to learn more about our deed transfer services and how we can assist you in successfully transferring property ownership. Trust Eagle Closing to handle your deed transfers with professionalism, integrity, and unwavering attention to detail.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Form with Parallax */}
      <ContactForm backgroundImage="/images/benjamin-franklin-bridge.jpg" />
    </motion.div>
  );
};

export default DeedTransfers;

